import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppConfig } from './../app-config';
import { BaseHttpService } from './base-http-service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseService<T> extends BaseHttpService<T> {
  baseUrl: string;
  principleUrl: string;

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
    this.baseUrl = this.config.getBaseApiUrl();
    this.principleUrl = this.config.getPrincipleUrl();
  }
}
